import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { Link } from 'components/Link';
import { Text } from 'components/Text/Text';

export function PageHeaderAmpPostListingLink() {
  return (
    <Link href="/post-a-listing">
      <Box classes={['flex', 'align-center']}>
        <Box mr={[14, null, null, '4px']} mt="1px" opacity={0.8}>
          <Icon name="pin" size={18} />
        </Box>
        <Text fontSize="inherit">{getText('Post a Listing')}</Text>
      </Box>
    </Link>
  );
}
